import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Error {
  response: {
    status: number
  }
}

interface Response {
  data: {
    first_available_end_date: string
    first_available_start_date: string
    reservation_end_date: string
    reservation_start_date: string
    restrictions: string[]
  }
}

export interface ProfessionalRestrictions {
  firstAvailableEndDate: Date
  firstAvailableStartDate: Date
  reservationEndDate: string
  reservationStartDate: string
  restrictions: Date[]
}

interface ProfessionalRestrictionsProps {
  professionalUsername: string
  patientUsername: string
  startDate: Date
  endDate: Date
  planCode?: string
}

export const professionalRestrictions = ({
  professionalUsername,
  patientUsername,
  startDate,
  endDate,
  planCode
}: ProfessionalRestrictionsProps): Promise<ProfessionalRestrictions> => {

  //eslint-disable-next-line
  const endpoint = apiEndpoints.RESTRICTIONS_PROFESSIONAL(professionalUsername)

  const params = {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    patient_username: patientUsername,
    plan_code: planCode
  }

  return new Promise<ProfessionalRestrictions> ((resolve, reject) => {
    axios.get(endpoint, { params })
      .then((response: Response) => {
        const result = {} as ProfessionalRestrictions
        
        result.firstAvailableEndDate = new Date(response.data.first_available_end_date)
        result.firstAvailableStartDate = new Date(response.data.first_available_start_date)
        result.reservationEndDate = response.data.reservation_end_date
        result.reservationStartDate = response.data.reservation_start_date
        result.restrictions = response.data.restrictions.map(restriction => new Date(restriction))
        
        resolve(result)
      })
      .catch((error: Error) => {
        reject(error.response.status)
      })
  })
}